import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CheckCircle2, Code2, Copy } from 'lucide-react';
import { api } from '../../../api/client';
import InfoTip from '../../../components/InfoTip';
import { toast } from '../../../lib/toast';

export default function TrackingScriptSection({ domain }) {
  const [copied, setCopied] = useState(false);

  const trackingQuery = useQuery({
    queryKey: ['tracking', domain._id],
    queryFn: () =>
      api.get(`/api/domains/${domain._id}/tracking-script`).then((r) => r.data),
  });

  const onCopy = async () => {
    const embed = trackingQuery.data?.embed;
    if (!embed) return;
    await navigator.clipboard.writeText(embed);
    setCopied(true);
    toast.success('Tracking snippet copied');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="card">
      <div className="section-header">
        <div className="section-title">
          <span className="section-icon">
            <Code2 className="w-4 h-4" />
          </span>
          Tracking script
          <InfoTip
            title="Why install this"
            body="A 5KB JS snippet that runs on your site. It detects when an AI engine's crawler hits a page (so we can show you AI bot traffic) and when a human visitor arrives from an AI assistant (so we can attribute referral traffic). Without it the Crawlers and AI Traffic tabs stay empty."
          />
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-3">
        Paste this into the <code>&lt;head&gt;</code> of every page on{' '}
        <code>{domain.domain}</code>. Detects AI bot crawls and AI-referred visitors.
      </p>
      {trackingQuery.data?.embed && (
        <div className="flex gap-2">
          <pre className="text-xs bg-gray-50 border border-gray-100 rounded-xl p-3 flex-1 overflow-auto scroll-soft whitespace-pre-wrap break-all">
            {trackingQuery.data.embed}
          </pre>
          <button className="btn-secondary flex-none" onClick={onCopy}>
            {copied ? (
              <>
                <CheckCircle2 className="w-4 h-4" /> Copied
              </>
            ) : (
              <>
                <Copy className="w-4 h-4" /> Copy
              </>
            )}
          </button>
        </div>
      )}
    </div>
  );
}
